export enum SendCostSheetMethod {
  WHATSAPP = "Via WhatsApp",
  EMAIL = "Via Email",
  EMAIL_AND_WHATSAPP = "Via Email & WhatsApp",
}
